import { Model } from "vue-mc";

export class StatusPreContacto extends Model {
  defaults() {
    return {
      clave: null
      , descripcion: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , descripcion: (descripcion) => descripcion
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/models/operativos/statusPreContacto.js